import { useState, useEffect } from "react";
import useLocalStorage from "../getLocalStorageData";

export default function useHomeAddress() {
  const { fcm, version } = useLocalStorage();

  const [homeAddress, setHomeAddress] = useState(
    `/${fcm !== "null" ? `?fcmToken=${fcm}` : ""}${
      version !== "null" ? `&version=${version}` : ""
    }`
  );

  useEffect(() => {
    setHomeAddress(
      `/${fcm !== "null" ? `?fcmToken=${fcm}` : ""}${
        version !== "null" ? `&version=${version}` : ""
      }`
    );
  }, [fcm, version]);

  return { homeAddress };
}
